import React from 'react';
import { motion } from 'framer-motion';
const styles = ['Neutral', 'Realism B&W', 'Horror', 'Realism', 'Fine Line', 'Irezumi', 'Black & Grey', 'Traditional', 'Watercolor', 'Geometric'];
export function StyleShowcase() {
  return <section className="py-20 border-y border-white/5 bg-white/[0.01] overflow-hidden" data-id="element-156">
      <div className="max-w-7xl mx-auto px-6 text-center" data-id="element-157">
        <motion.h3 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-3xl font-black tracking-tighter mb-10" data-id="element-158">
          Master any tattoo style
        </motion.h3>

        <div className="flex flex-wrap justify-center gap-4 max-w-4xl mx-auto" data-id="element-159">
          {styles.map((style, index) => <motion.div key={style} initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="px-6 py-3 rounded-full border border-white/10 bg-white/5 text-gray-300 font-semibold hover:bg-white/10 hover:border-tatan-blue/50 hover:text-white transition-all cursor-default" data-id="element-160">
              {style}
            </motion.div>)}
        </div>
      </div>
    </section>;
}